import { ActionTree } from "vuex";
import {
  RecipesState,
  RootState,
  RequestRecipeDetail,
  RecipeDetailInfo,
  FavoriteOperationResult,
  FavoriteFolders,
  FavoriteRecipeClips
} from "@/types/recipes";
import apiClient from "@/client/api-client";
import { API_URL_RECIPE } from "@/const/api-const";
import store from "@/store";
import { getApplianceListText } from "@/utils/search-util";
import NativeClient from "@/client/native-client";

const actions: ActionTree<RecipesState, RootState> = {
  updateRecipeDetail: async (
    { commit },
    detailInfo: RecipeDetailInfo | null
  ) => {
    commit("updateRecipeDetail", detailInfo);
  },
  getRecipeDetail: async ({ commit }, payload: RequestRecipeDetail) => {
    // Nativeから受け取った認証関連パラメータを取得
    const apiParams = store.getters["common/getApiBaseParams"];
    let applianceText = null;
    if (payload.applianceList == null || payload.applianceList.length == 0) {
      applianceText = getApplianceListText(apiParams.applianceList);
    } else {
      applianceText = "";
      for (const productCode of payload.applianceList) {
        if (applianceText != "") {
          applianceText += ",";
        }
        applianceText += productCode;
      }
    }
    // レシピ詳細API呼び出し
    const res = await apiClient.get(API_URL_RECIPE.DETAIL, {
      params: {
        /** レシピタイプ */
        type: payload.type,
        /** レシピID */
        id: payload.id,
        /** 人数 */
        servings: payload.servings,
        /** テーマ */
        theme: payload.theme,
        /** 機器 */
        myAppliance: applianceText
      }
    });
    commit("updateRecipeDetail", new RecipeDetailInfo(res.data));
  },
  // お気に入り一覧取得（トップ用、最近追加したもの）
  getRecentMyList: async ({ commit }) => {
    // お気に入りレシピ取得API呼び出し
    const apiParams = store.getters["common/getApiBaseParams"];
    const applianceText = getApplianceListText(apiParams.applianceList);
    const res = await apiClient.get(API_URL_RECIPE.MYLIST, {
      params: {
        // My家電ID
        myAppliance: (applianceText != null) ? applianceText : null,
        // 「ホーム > マイリスト」画面と「お気に入りを追加 > マイリストから選ぶ」 の画面で、表示するレシピを出し分けるために利用するパラメータ。
        needDlMenuId: false,
        // 取得開始位置（すでに取得済みの場合、取得した件数以降の開始位置を指定）
        start: 0,
        // 10件
        row: 10
      }
    });
    NativeClient.sendDebugLog("Action.ts getMyList recipeList.count = ");

    commit("updateRecentMyList", res.data);
  },
  updateRecentMyList: async ({ commit }, clips: FavoriteRecipeClips | null) => {
    commit("updateRecentMyList", clips);
  },
  // フォルダ一覧
  getFolderList: async ({ commit }) => {
    const apiParams = store.getters["common/getApiBaseParams"];
    // お気に入りフォルダ一取得API呼び出し
    const applianceText = getApplianceListText(apiParams.applianceList);
    const res = await apiClient.get(API_URL_RECIPE.MYLIST_FOLDER_LIST, {
      params: {
        myAppliance: applianceText != null ? applianceText : null
      }
    });
    commit("updateFolderList", res.data);
  },
  updateFolderList: async ({ commit }, result: FavoriteFolders | null) => {
    commit("updateFolderList", result);
  },
  // レシピ登録
  addRecipeMyList: async ({ commit }, param: {recipeId: number, folderIds: Array<number>} ) => {
    const folderIdList = (param.folderIds && param.folderIds.length >= 1) ? param.folderIds : null;
    NativeClient.sendDebugLog("addRecipeMyList recipeId=" + param.recipeId + " folderIds=" + JSON.stringify(param.folderIds));
    // レシピ削除API呼び出し
    const res = await apiClient.post(API_URL_RECIPE.MYLIST_RECIPE_ADD, {
      // レシピID
      recipeId: param.recipeId,
      favoriteFolderIds: folderIdList
    });
    commit("updateAddRecipeMyList", res.data);
  },
  updateAddRecipeMyList: async (
    { commit },
    result: FavoriteOperationResult | null
  ) => {
    commit("updateAddRecipeMyList", result);
  },
  // レシピ削除
  deleteRecipeMyList: async ({ commit }, recipeId: number) => {
    const result: FavoriteOperationResult | null =
      store.getters["favorites/deleteRecipe"];
    // レシピ削除API呼び出し
    const res = await apiClient.post(API_URL_RECIPE.MYLIST_RECIPE_DELETE, {
      recipeId: recipeId
    });
    commit("updateDeleteRecipeMyList", res.data);
  },
  updateDeleteRecipeMyList: async (
    { commit },
    result: FavoriteOperationResult | null
  ) => {
    commit("updateDeleteRecipeMyList", result);
  }
};

export default actions;
